// esenz light — minimal

(() => {
  const mobileNavMenu = document.querySelector('.mobile-nav-menu');

  if (mobileNavMenu) {
    const setMobileNavOpen = (isOpen) => {
      mobileNavMenu.open = isOpen;
      document.documentElement.classList.toggle('mobile-nav-lock', isOpen);
    };

    mobileNavMenu.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('mobile-nav-lock', mobileNavMenu.open);
    });

    mobileNavMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMobileNavOpen(false));
    });

    document.addEventListener('click', (event) => {
      if (!mobileNavMenu.open || mobileNavMenu.contains(event.target)) return;
      setMobileNavOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setMobileNavOpen(false);
    });
  }

  const modal = document.querySelector('[data-quiz-modal]');
  const openButtons = document.querySelectorAll('[data-quiz-open]');
  const closeButtons = document.querySelectorAll('[data-quiz-close]');

  const setModalOpen = (isOpen) => {
    if (!modal) return;
    modal.classList.toggle('is-open', isOpen);
    modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('quiz-modal-lock', isOpen);
    if (isOpen) modal.dispatchEvent(new CustomEvent('quiz:open'));
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (!modal) return;
      event.preventDefault();
      setModalOpen(true);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', () => setModalOpen(false));
  });

  if (modal && window.location.hash === '#quiz-modal') {
    window.setTimeout(() => setModalOpen(true), 120);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setModalOpen(false);
  });

  const quizzes = document.querySelectorAll('[data-esenz-quiz]');

  quizzes.forEach((quiz) => {
    const steps = Array.from(quiz.querySelectorAll('[data-quiz-step]'));
    const result = quiz.querySelector('[data-quiz-result]');
    const loader = quiz.querySelector('[data-quiz-loader]');
    const emailStep = quiz.querySelector('[data-quiz-email-step]');
    const progress = quiz.querySelector('[data-quiz-progress]');
    const nextButtons = quiz.querySelectorAll('[data-quiz-next]');
    const resetButton = quiz.querySelector('[data-quiz-reset]');
    const emailForm = quiz.querySelector('.quiz-email-form');
    const emailInput = quiz.querySelector('[data-quiz-email-input]');
    const skipEmailButton = quiz.querySelector('[data-quiz-skip-email]');
    const tagsInput = quiz.querySelector('[data-quiz-tags]');
    const noteInput = quiz.querySelector('[data-quiz-note]');
    const leadFrameName = 'quiz-lead-frame';
    let current = 0;
    let loaderTimer = null;
    let answers = {};

    const screens = [...steps, loader, emailStep, result].filter(Boolean);

    const answerLabel = {
      age: 'Alter',
      supplement_status: 'Nimmt Supplements',
      supplement_type: 'Aktuelle Supplements',
      supplement_problem: 'Problem',
      desired_outcome: 'Ziel'
    };

    const slugify = (value) => value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 42);

    const setProgress = (value) => {
      if (!progress) return;
      progress.style.width = `${value}%`;
    };

    const updateLeadFields = () => {
      const answerEntries = Object.entries(answers).filter(([, value]) => value);
      const answerTags = answerEntries.map(([key, value]) => `quiz-${slugify(key)}-${slugify(value)}`);

      if (tagsInput) {
        tagsInput.value = ['quiz', 'kern-esenz', ...answerTags].join(',');
      }

      if (noteInput) {
        const summary = answerEntries.map(([key, value]) => `${answerLabel[key] || key}: ${value}`).join(' | ');
        noteInput.value = summary ? `Kern Esenz Quiz | ${summary}` : 'Kern Esenz Quiz';
      }
    };

    const clearScreens = () => {
      screens.forEach((screen) => screen.classList.remove('is-active'));
    };

    const showStep = (index) => {
      window.clearTimeout(loaderTimer);
      clearScreens();
      steps[index]?.classList.add('is-active');
      current = index;
      setProgress(((current + 1) / steps.length) * 82);
    };

    const showResult = () => {
      window.clearTimeout(loaderTimer);
      clearScreens();
      result?.classList.add('is-active');
      setProgress(100);
      updateLeadFields();
    };

    const showEmailStep = () => {
      clearScreens();
      emailStep?.classList.add('is-active');
      setProgress(100);
      updateLeadFields();
      window.setTimeout(() => emailInput?.focus(), 120);
    };

    const showLoader = () => {
      clearScreens();
      loader?.classList.add('is-active');
      setProgress(94);
      updateLeadFields();
      loaderTimer = window.setTimeout(() => {
        if (emailStep) {
          showEmailStep();
          return;
        }
        showResult();
      }, 3800);
    };

    const resetQuiz = () => {
      answers = {};
      window.clearTimeout(loaderTimer);
      quiz.querySelectorAll('.quiz-options button').forEach((button) => button.classList.remove('is-selected'));
      emailForm?.reset();
      updateLeadFields();
      showStep(0);
    };

    if (emailForm) {
      emailForm.setAttribute('target', leadFrameName);

      if (!document.querySelector(`iframe[name="${leadFrameName}"]`)) {
        const leadFrame = document.createElement('iframe');
        leadFrame.name = leadFrameName;
        leadFrame.title = 'Quiz Lead';
        leadFrame.hidden = true;
        quiz.appendChild(leadFrame);
      }
    }

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const step = button.closest('[data-quiz-step]');
        const stepName = step?.dataset.quizStepName;
        const answer = button.dataset.quizAnswer || button.textContent.trim();

        if (stepName) {
          answers[stepName] = answer;
        }

        if (stepName === 'supplement_status' && answer === 'Nein') {
          delete answers.supplement_type;
          delete answers.supplement_problem;
        }

        button.closest('.quiz-options')?.querySelectorAll('[data-quiz-next]').forEach((option) => {
          option.classList.toggle('is-selected', option === button);
        });

        updateLeadFields();

        if (stepName === 'desired_outcome' || (!stepName && current >= steps.length - 1)) {
          window.setTimeout(() => {
            if (loader) {
              showLoader();
              return;
            }
            showResult();
          }, 180);
          return;
        }

        const nextIndex = Number.isFinite(Number.parseInt(button.dataset.quizNextStep, 10))
          ? Number.parseInt(button.dataset.quizNextStep, 10)
          : current + 1;

        window.setTimeout(() => showStep(nextIndex), 150);
      });
    });

    emailForm?.addEventListener('submit', (event) => {
      if (!emailInput?.value.trim()) {
        event.preventDefault();
        emailInput?.focus();
        return;
      }

      updateLeadFields();
      window.setTimeout(showResult, 700);
    });

    skipEmailButton?.addEventListener('click', showResult);
    resetButton?.addEventListener('click', resetQuiz);
    modal?.addEventListener('quiz:open', resetQuiz);
    resetQuiz();
  });

  const productMainImage = document.querySelector('[data-product-main-image]');
  const galleryButtons = document.querySelectorAll('[data-product-gallery-thumb]');
  const formatButtons = document.querySelectorAll('[data-product-format]');
  const productPackagingProperties = document.querySelectorAll('[data-product-packaging-property]');

  galleryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!productMainImage || !button.dataset.image) return;

      productMainImage.src = button.dataset.image;
      if (button.dataset.alt) productMainImage.alt = button.dataset.alt;
      galleryButtons.forEach((option) => option.classList.toggle('is-active', option === button));
    });
  });

  formatButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.classList.contains('is-disabled')) return;

      formatButtons.forEach((option) => option.classList.toggle('is-selected', option === button));

      if (button.dataset.packagingValue) {
        productPackagingProperties.forEach((input) => {
          input.value = button.dataset.packagingValue;
        });
        galleryButtons.forEach((option) => option.classList.remove('is-active'));
      }

      if (!productMainImage || !button.dataset.image) return;
      productMainImage.src = button.dataset.image;
      if (button.dataset.alt) productMainImage.alt = button.dataset.alt;
    });
  });

  const supplyButtons = document.querySelectorAll('[data-supply-option]');
  const productQuantityInputs = document.querySelectorAll('[data-product-quantity]');
  const productOfferProperties = document.querySelectorAll('[data-product-offer-property]');
  const productBonusProperties = document.querySelectorAll('[data-product-bonus-property]');
  const productAddLabels = document.querySelectorAll('[data-product-add-label]');

  supplyButtons.forEach((button) => {
    button.addEventListener('click', () => {
      supplyButtons.forEach((option) => option.classList.toggle('is-selected', option === button));

      if (button.dataset.quantity) {
        productQuantityInputs.forEach((input) => {
          input.value = button.dataset.quantity;
        });
      }

      productOfferProperties.forEach((input) => {
        input.value = button.dataset.offerLabel || '';
      });

      productBonusProperties.forEach((input) => {
        const bonusLabel = button.dataset.bonusLabel || '';
        input.value = bonusLabel;
        input.disabled = !bonusLabel;
      });

      if (button.dataset.buttonLabel) {
        productAddLabels.forEach((label) => {
          label.textContent = button.dataset.buttonLabel;
        });
      }
    });
  });

  const reviewTrack = document.querySelector('[data-review-track]');
  const reviewPrev = document.querySelector('[data-review-prev]');
  const reviewNext = document.querySelector('[data-review-next]');
  document.querySelectorAll('.review-bars').forEach((bars) => bars.remove());
  document.querySelectorAll('.product-ingredients-visual').forEach((visual) => visual.remove());

  const scrollReviews = (direction) => {
    if (!reviewTrack) return;
    const firstCard = reviewTrack.querySelector('.community-review-card');
    const gap = Number.parseFloat(window.getComputedStyle(reviewTrack).columnGap || '0');
    const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : reviewTrack.clientWidth;
    reviewTrack.scrollBy({ left: direction * distance, behavior: 'smooth' });
  };

  reviewPrev?.addEventListener('click', () => scrollReviews(-1));
  reviewNext?.addEventListener('click', () => scrollReviews(1));

  const productTimeline = document.querySelector('.product-timeline');
  const productTimelineItems = productTimeline ? Array.from(productTimeline.querySelectorAll('article')) : [];

  if (productTimeline && productTimelineItems.length) {
    let timelineFrame = null;

    const updateProductTimeline = () => {
      timelineFrame = null;
      const timelineRect = productTimeline.getBoundingClientRect();
      const triggerY = window.innerHeight * 0.5;
      const firstDot = productTimelineItems[0].offsetTop + 9;
      const lastDot = productTimelineItems[productTimelineItems.length - 1].offsetTop + 9;
      const localTrigger = triggerY - timelineRect.top;
      const progress = Math.max(0, Math.min(1, (localTrigger - firstDot) / Math.max(1, lastDot - firstDot)));
      let activeIndex = 0;

      productTimelineItems.forEach((item, index) => {
        const dotTop = item.offsetTop + 9;
        if (localTrigger >= dotTop - 30) activeIndex = index;
      });

      productTimeline.style.setProperty('--timeline-progress', `${(progress * Math.max(1, lastDot - firstDot)).toFixed(1)}px`);
      productTimelineItems.forEach((item, index) => {
        item.classList.toggle('active', index === activeIndex);
      });
    };

    const requestProductTimelineUpdate = () => {
      if (timelineFrame) return;
      timelineFrame = window.requestAnimationFrame(updateProductTimeline);
    };

    window.addEventListener('scroll', requestProductTimelineUpdate, { passive: true });
    window.addEventListener('resize', requestProductTimelineUpdate);
    updateProductTimeline();
  }

  const capsuleWaitlistModal = document.querySelector('[data-capsule-waitlist-modal]');
  const capsuleWaitlistOpenButtons = document.querySelectorAll('[data-capsule-waitlist-open]');
  const capsuleWaitlistCloseButtons = document.querySelectorAll('[data-capsule-waitlist-close]');

  const setCapsuleWaitlistOpen = (isOpen) => {
    if (!capsuleWaitlistModal) return;
    capsuleWaitlistModal.classList.toggle('is-open', isOpen);
    capsuleWaitlistModal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle('quiz-modal-lock', isOpen);
    if (isOpen) {
      window.setTimeout(() => capsuleWaitlistModal.querySelector('input[type="email"]')?.focus(), 80);
    }
  };

  capsuleWaitlistOpenButtons.forEach((button) => {
    button.addEventListener('click', () => setCapsuleWaitlistOpen(true));
  });

  capsuleWaitlistCloseButtons.forEach((button) => {
    button.addEventListener('click', () => setCapsuleWaitlistOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setCapsuleWaitlistOpen(false);
  });

  const verifiedReviewGrid = document.querySelector('[data-verified-review-grid]');
  const verifiedReviewPagination = document.querySelector('[data-verified-review-pagination]');
  const verifiedReviewCards = verifiedReviewGrid ? Array.from(verifiedReviewGrid.querySelectorAll('article')) : [];
  const verifiedReviewsPerPage = 12;

  if (verifiedReviewGrid && verifiedReviewPagination && verifiedReviewCards.length > verifiedReviewsPerPage) {
    const pageCount = Math.ceil(verifiedReviewCards.length / verifiedReviewsPerPage);
    let activePage = 1;

    const showVerifiedReviewPage = (page) => {
      activePage = page;
      verifiedReviewCards.forEach((card, index) => {
        const cardPage = Math.floor(index / verifiedReviewsPerPage) + 1;
        card.classList.toggle('is-hidden', cardPage !== activePage);
      });
      verifiedReviewPagination.querySelectorAll('button').forEach((button) => {
        const isActive = Number(button.dataset.reviewPage) === activePage;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-current', isActive ? 'page' : 'false');
      });
    };

    for (let page = 1; page <= pageCount; page += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.reviewPage = String(page);
      button.textContent = String(page);
      button.setAttribute('aria-label', `Review Seite ${page}`);
      button.addEventListener('click', () => {
        showVerifiedReviewPage(page);
        verifiedReviewGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      verifiedReviewPagination.appendChild(button);
    }

    showVerifiedReviewPage(1);
  }
})();
